
import LoginCarImage from '../components/login/LoginCarImage.vue';
import LoginSection from '../components/login/LoginSection.vue';
import { addTheme } from '../libs/helpers';

export default {
  components: { LoginSection, LoginCarImage },

  created() {
    addTheme(this.getEnvironmentLayoutName());
  },
};
